export function getUserLocalData() {
  const str = localStorage.getItem('UserInfo') || '{}'
  const obj = JSON.parse(str)
  return obj
}

export function queryGrayTestList(code) { // 灰度查询
  const { grayTestList = [] } = getUserLocalData()
  return grayTestList.some((item, index) => {
    return item.code === code
  })
}

export function queryGrayTest(key) {
  let isGrayEnv = false
  const isAccountGray = queryGrayTestList(key || '2024_LLM_RELEASE_MATH')
  if (isAccountGray) {
    isGrayEnv = true
  }
  return isGrayEnv
}

 // 判断是松鼠AI APP
export function isSSAI () {
  return /SSAI_Android|SSAI_iOS$/.test(navigator.userAgent)
}

// 登录态失效，重新拿authkey登录学习中心 - jsBridgeForSSAI('closePage')
export function jsBridgeForSSAI (action, params, callback) {
  var ua = navigator.userAgent
  var data = {
    action,
    params: params || {},
    callback: callback || ''
  }
  data = JSON.stringify(data)
  try {
    if (/SSAI_Android$/.test(ua)) {
      window.ssaiAppJS.postMessage(data)
    } else {
      if (!isSSAI()) {
        return 'error'
      }
      window.webkit.messageHandlers.ssaiAppJS.postMessage(data)
    }
  } catch (error) {
    console.log(error, 'monitor访问APP协议异常！')
    return 'error'
  }
}

export function generateUUID () {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid.replace(/-/g, "");
}
